const FETCH_ENROLLMENT_HISTORY = "FETCH_ENROLLMENT_HISTORY";
const FETCH_ENROLLMENT_HISTORY_SUCCESS = "FETCH_ENROLLMENT_HISTORY_SUCCESS";
const FETCH_ENROLLMENT_HISTORY_ERROR = "FETCH_ENROLLMENT_HISTORY_ERROR";

const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
const SET_ENROLLMENT_HISTORY_MANAGER_STATE =
  "SET_ENROLLMENT_HISTORY_MANAGER_STATE";

export {
  FETCH_ENROLLMENT_HISTORY,
  FETCH_ENROLLMENT_HISTORY_SUCCESS,
  FETCH_ENROLLMENT_HISTORY_ERROR,
  IS_ADDING_UPDATE,
  SET_ENROLLMENT_HISTORY_MANAGER_STATE,
};
